import { DeliveryOrderStatus } from '@diamond/shared/types';

export const ORDER_DETAIL_CONSTANTS = {
  STATUS: {
    WAITING_FOR_PAYMENT: 'waiting_for_payment',
    CANCELLED: 'cancelled',
    SUBMITTED: 'submitted',
    PROCESSED: 'processed',
    PARTIALLY_PROCESSED: 'partially_processed',
    OUT_FOR_DELIVERY: 'out_for_delivery',
    PARTIALLY_OUT_FOR_DELIVERY: 'partially_out_for_delivery',
    RECEIVED: 'received',
    PARTIALLY_RECEIVED: 'partially_received',
    DRAFT: 'draft',
    REJECTED: 'rejected',
    DELIVERED: 'delivered',
  },
  ELEMENT_IDS: {
    PAYMENT_PROOF_SECTION: 'submit-payment-proof',
  },
  SCROLL_BEHAVIOR: {
    SMOOTH: 'smooth' as const,
  },
  DATE_FORMAT: {
    ORDER_DETAIL_DATETIME: 'dd MMM yyyy • HH:mm',
  },
  PAYMENT_PROOF: {
    MAX_FILES: 5,
    MAX_SIZE_MB: 5,
    ALLOWED_FORMATS: ['PDF', 'PNG', 'JPG'],
  },
} as const;

// ==================== Cancel Reasons ====================
// Standardized cancellation reasons from cancel_reasons table
// Used for identifying specific cancellation scenarios
export const CANCEL_REASONS = {
  TRANSFER_EXPIRED: 'Lewat Batas Transfer',
} as const;

// ==================== Delivery Order Status Config (DO) ====================
// Used for individual shipment statuses (e.g., Diproses, Dikirim, Diterima)
// displayed inside the expanded order details.
export const DO_STATUS_CONFIG: Record<
  DeliveryOrderStatus,
  { label: string; color: string; bg: string; dotColor: string }
> = {
  processed: {
    label: 'Dikemas',
    color: '#0000A3',
    bg: 'rgba(82, 0, 163, 0.1)',
    dotColor: '#00C3D0',
  },
  delivered: {
    label: 'Dikirim',
    color: '#0068A3',
    bg: 'rgba(0, 104, 163, 0.1)',
    dotColor: '#0068A3',
  },
  received: {
    label: 'Diterima',
    color: '#16A34A',
    bg: 'rgba(22, 163, 74, 0.1)',
    dotColor: '#16A34A',
  },
  partially_received: {
    label: 'Diterima Sebagian',
    color: '#005527',
    bg: 'rgba(0, 85, 39, 0.1)',
    dotColor: '#005527',
  },
  rejected: {
    label: 'Ditolak',
    color: '#DC2626',
    bg: 'rgba(220, 38, 38, 0.1)',
    dotColor: '#FF383C',
  },
  cancelled: {
    label: 'Dibatalkan',
    color: '#FF383C',
    bg: 'rgba(120, 113, 108, 0.1)',
    dotColor: '#FF383C',
  },
};

// ==================== SO (Sales Order) Status Config ====================
// Used for aggregate Sales Order status badges (e.g., Selesai Sebagian, Dibatalkan)
// displayed on the collapsed order row.
export type SOStatus =
  | 'pending'
  | 'waiting_confirmation'
  | 'processing'
  | 'partial_processing'
  | 'delivering'
  | 'partial_delivering'
  | 'completed'
  | 'partial_completed'
  | 'cancelled';

export const SO_STATUS_CONFIG: Record<
  SOStatus,
  { label: string; color: string; bg: string; dotColor?: string }
> = {
  pending: {
    label: 'Menunggu Pembayaran',
    color: '#373F41',
    bg: '#FFF9E1',
  },
  waiting_confirmation: {
    label: 'Menunggu Konfirmasi',
    color: '#373F41',
    bg: '#F8F7FF',
    dotColor: '#6155F5',
  },
  processing: {
    label: 'Diproses',
    color: '#373F41',
    bg: '#F1F8FF',
    dotColor: '#007AFF',
  },
  partial_processing: {
    label: 'Diproses Sebagian',
    color: '#373F41',
    bg: 'rgba(241, 248, 255, 1)',
    dotColor: '#007AFF',
  },
  delivering: {
    label: 'Dikirim',
    color: '#373F41',
    bg: 'rgba(0, 104, 163, 0.1)',
    dotColor: '#00C3D0',
  },
  partial_delivering: {
    label: 'Dikirim Sebagian',
    color: '#373F41',
    bg: 'rgba(0, 104, 163, 0.1)',
    dotColor: '#0068A3',
  },
  completed: {
    label: 'Selesai',
    color: '#373F41',
    bg: '#EAFFF0',
    dotColor: '#34C759',
  },
  partial_completed: {
    label: 'Selesai Sebagian',
    color: '#373F41',
    bg: 'rgba(0, 85, 39, 0.1)',
  },
  cancelled: {
    label: 'Dibatalkan',
    color: '#373F41',
    dotColor: '#FF383C',
    bg: 'rgba(255, 56, 60, 0.1)',
  },
};
